import React from 'react';
import css from './CheckboxInput.module.css';
import classNames from 'classnames';

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
    id?: string;
    disabled?: boolean;
    className?: string;
    readOnly?: boolean;
}

const CheckboxInput: React.FC<CheckboxProps> = ({
    id,
    disabled = false,
    className,
    readOnly,
    ...rest
}) => {
    return (
        <div className={css.checkboxWrapper}>
            <input
                type="checkbox"
                disabled={disabled}
                className={classNames(css.checkbox, className, {
                    [css.readOnly]: readOnly,
                })}
                readOnly={readOnly}
                {...rest}
            />
            <label htmlFor={id}></label>
        </div>
    );
};

export default React.memo(CheckboxInput);
